module.exports = __webpack_public_path__ + "img/logo_8_gb-energy.8bc327c9.jpg";